import qs from "qs";
import { useHistory, useLocation } from "react-router-dom";

export const useSetLocationData = (useReplace = false) => {
  const history = useHistory();
  const location = useLocation();

  const parameters = location.search ? qs.parse(location.search.slice(1)) : {};

  return (
    name,
    val,
    name2 = "",
    val2 = null,
    name3 = "",
    val3 = null,
    name4 = "",
    val4 = null,
    name5 = "",
    val5 = null,
    name6 = "",
    val6 = null,
    name7 = "",
    val7 = null,
    name8 = "",
    val8 = null,
    name9 = "",
    val9 = null,
  ) => {
    history[useReplace ? "replace" : "push"]({
      search: qs.stringify(
        name9
          ? {
              ...parameters,
              [name]: val,
              [name2]: val2,
              [name3]: val3,
              [name4]: val4,
              [name5]: val5,
              [name6]: val6,
              [name7]: val7,
              [name8]: val8,
              [name9]: val9,
            }
          : name8
            ? {
                ...parameters,
                [name]: val,
                [name2]: val2,
                [name3]: val3,
                [name4]: val4,
                [name5]: val5,
                [name6]: val6,
                [name7]: val7,
                [name8]: val8,
              }
            : name7
              ? {
                  ...parameters,
                  [name]: val,
                  [name2]: val2,
                  [name3]: val3,
                  [name4]: val4,
                  [name5]: val5,
                  [name6]: val6,
                  [name7]: val7,
                }
              : name6
                ? {
                    ...parameters,
                    [name]: val,
                    [name2]: val2,
                    [name3]: val3,
                    [name4]: val4,
                    [name5]: val5,
                    [name6]: val6,
                  }
                : name5
                  ? {
                      ...parameters,
                      [name]: val,
                      [name2]: val2,
                      [name3]: val3,
                      [name4]: val4,
                      [name5]: val5,
                    }
                  : name4
                    ? {
                        ...parameters,
                        [name]: val,
                        [name2]: val2,
                        [name3]: val3,
                        [name4]: val4,
                      }
                    : name3
                      ? {
                          ...parameters,
                          [name]: val,
                          [name2]: val2,
                          [name3]: val3,
                        }
                      : name2
                        ? { ...parameters, [name]: val, [name2]: val2 }
                        : { ...parameters, [name]: val },
      ),
    });
  };
};

export const useGetLocationData = () => {
  const location = useLocation();
  const currentParameters = location.search
    ? qs.parse(location.search.slice(1))
    : {};

  const checkEmpty = (name) => (name ? String(name) : "");

  const {
    page,
    count,
    searchField,
    searchText,
    sortField,
    link,
    sortSubField,
    sortType,
    searchTextForSelect,
    dateBegin,
    dateEnd,
    currentId,
    selectedDate,
    openModal,
    openChildModal,
    fullname,
    event,
    UserId,
    isFull,
    noCaching,
    code,
    name,
    status,
    parentSubdivision,
    filterExpectations,
    selected,
    openType,
    fileId,
    filesId,
    UUID,
    pageModal,
    countModal,
  } = currentParameters;

  return {
    ...currentParameters,
    page: Number(page) || 0,
    count: Number(count) || 25,
    pageModal: Number(pageModal) || 0,
    countModal: Number(countModal) || 25,
    sortField: sortField && String(sortField),
    sortType: sortType && String(sortType),
    sortSubField: sortSubField && String(sortSubField),
    searchField: checkEmpty(searchField),
    link: checkEmpty(link),
    searchText: checkEmpty(searchText),
    filterExpectations: checkEmpty(filterExpectations),
    searchTextForSelect: checkEmpty(searchTextForSelect),
    dateBegin: checkEmpty(dateBegin),
    dateEnd: checkEmpty(dateEnd),
    currentId: checkEmpty(currentId),
    selectedDate: checkEmpty(selectedDate),
    openModal: checkEmpty(openModal),
    selected: checkEmpty(selected),
    openChildModal: checkEmpty(openChildModal),
    fullname: checkEmpty(fullname),
    event: checkEmpty(event),
    UserId: checkEmpty(UserId),
    isFull: String(isFull) || Boolean(isFull),
    noCaching: Boolean(noCaching),
    code: checkEmpty(code),
    name: checkEmpty(name),
    status: status,
    parentSubdivision: parentSubdivision,
    openType,
    fileId: fileId && String(fileId),
    filesId: filesId && String(filesId),
    UUID: checkEmpty(UUID),
  };
};

export const useGoToPreviousPage = () => {
  const history = useHistory();
  const firstPathname = history.location.pathname;
  const lastPathname = firstPathname.split("/").slice(0, -2).join("/") + "/";
  return () => {
    history.replace(lastPathname);
  };
};
